"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("../../styles");

var styles = {
  root: {
    opacity: 1,
    width: '100%',
    height: '35px',
    display: 'flex',
    alignItems: 'center',
    padding: '0 15px',
    color: _styles.colors.white,
    transition: 'opacity 0.3s, height 0.3s',
    background: function background(_ref) {
      var type = _ref.type;
      if (type === 'success') return _styles.colors.green;
      if (type === 'warning') return _styles.colors.orange;
      if (type === 'error') return _styles.colors.red;
      return '';
    }
  },
  hidden: {
    opacity: 0,
    height: 0,
    padding: 0
  },
  closeIcon: {
    height: '12px',
    width: '12px',
    fill: _styles.colors.white,
    cursor: 'pointer',
    marginLeft: 'auto'
  }
};
var _default = styles;
exports["default"] = _default;